// @ts-nocheck

/**
 * * `CHAT_ACTIVE` - Chatting
 * `PLOT_REFINING` - Refining Plot
 * `PLOT_READY` - Plot Ready
 * `SLIDES_GENERATING` - Generating Slide Previews
 * `SLIDES_READY` - Ready for Review
 * `FINALIZING` - Starting Full Generation
 * `COMPLETED` - Story Created
 * `EXPIRED` - Expired
 * `CANCELLED` - Cancelled
 */
export type StoryCreationSessionStatusEnum =
  typeof StoryCreationSessionStatusEnum[keyof typeof StoryCreationSessionStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StoryCreationSessionStatusEnum = {
  CHAT_ACTIVE: "CHAT_ACTIVE",
  PLOT_REFINING: "PLOT_REFINING",
  PLOT_READY: "PLOT_READY",
  SLIDES_GENERATING: "SLIDES_GENERATING",
  SLIDES_READY: "SLIDES_READY",
  FINALIZING: "FINALIZING",
  COMPLETED: "COMPLETED",
  EXPIRED: "EXPIRED",
  CANCELLED: "CANCELLED",
} as const;
